<template>
  <div>
    <v-toolbar flat>
      <DateInput
        label="von"
        v-model="startDate"
        hideDetails
        class="mr-2"
        clearable
      ></DateInput>
      <DateInput
        label="bis"
        v-model="endDate"
        hideDetails
        class="mx-2"
        clearable
      ></DateInput>

      <v-spacer></v-spacer>
      <ReportButton
        outlined
        text
        resource="report/invoicetransfers"
        color="danger"
        :disabled="!startDate || !endDate"
        :parameters="{
          startDate: startDate,
          endDate: endDate,
        }"
        >PDF</ReportButton
      >
    </v-toolbar>
    <v-divider></v-divider>
    <TableComponent
      :items="items"
      :loading="loading"
      @showDetails="showDetails"
      expenses
    />

    <router-view @update="update"></router-view>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import DateInput from "common/components/DateInput.vue";
import ReportButton from "@/components/ReportButton";
import TableComponent from "./TableComponent.vue";

export default defineComponent({
  name: "FinanceInvoicesTransfers",
  components: {
    DateInput,
    ReportButton,
    TableComponent,
  },
  props: ["search"],
  data() {
    return {
      items: [],
      loading: false,
      startDate: "",
      endDate: "",
    };
  },
  watch: {
    startDate() {
      this.fetchData();
    },
    endDate() {
      this.fetchData();
    },
  },
  methods: {
    update() {
      this.fetchData();
      this.$emit("update");
    },
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/invoicetransfers",
        query: `startDate=${this.startDate}&endDate=${this.endDate}`,
      });

      this.loading = false;
    },
    showDetails(id) {
      this.$router.push({
        name: "FinanceInvoicesTransfersDetail",
        params: { id: id },
      });
    },
  },
  async created() {
    await this.fetchData();
  },
});
</script>
